import axios from "axios";

import type { ActiveNotificationBarResponse } from "../Models/DTOs/NotificationBarDTO";

const WEB_API_BASE = (process.env.REACT_APP_WEB_API_URL ?? "").replace(/\/$/, "");

export async function GetNotificationBar(
    abortController: AbortController
): Promise<ActiveNotificationBarResponse> {
    const response = await axios.get<ActiveNotificationBarResponse>(
        `${WEB_API_BASE}/v1/notification-bars/active`,
        { signal: abortController.signal }
    );

    return response.data;
}
